var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, Flex } from '@chakra-ui/react';
import { rem } from 'polished';
export const CheckBox = (_a) => {
    var { isActive, label, textColor = 'text' } = _a, props = __rest(_a, ["isActive", "label", "textColor"]);
    return (_jsxs(Flex, Object.assign({ w: "100%", align: "center" }, { children: [_jsx(Checkbox, Object.assign({}, props, { isChecked: isActive, marginTop: 0, marginRight: rem(16), borderColor: "#f80505", variant: "primary", color: textColor, sx: { width: rem(16), height: rem(16), borderColor: textColor } })), _jsx(Flex, Object.assign({ as: "span", color: textColor }, { children: label }))] })));
};
//# sourceMappingURL=Checkbox.js.map